export * from './details/details.controller';
export * from './details/IKubernetesSecurityGroup';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/kubernetes/src/v2/securityGroup/index.ts